import { useTranslation } from 'react-i18next';
import {
  setAIAssistantDisplayed,
  setAIAssistantMinimized,
  setAIAssistantStartNewChatOnOpen,
} from '@/aiAssistant/aiAssistant.actions';
import { useAiAssistantDisplayed, useAiAssistantMinimized } from '@/aiAssistant/aiAssistant.store';
import { sqWorkbenchStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { doTrack } from '@/track/track.service';
import { Icon } from '@seeqdev/qomponents';

export const HeaderAIAssistant = () => {
  const currentUser = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.currentUser);
  const aiAssistantDisplayed = useAiAssistantDisplayed();
  const aiAssistantMinimized = useAiAssistantMinimized();
  const { t } = useTranslation();

  if (!currentUser.isTrusted) {
    return null;
  }

  return (
    <>
      <Icon
        icon="fa-sparkles"
        iconPrefix="fa-solid"
        testId="headerAIIcon"
        type="white"
        extraClassNames="pl5 pt3 pr5 sq-navbar-default fa-xl"
        tooltip={t('AI_ASSISTANT.AI_ASSISTANT')}
        tooltipPlacement="bottom"
        onClick={() => {
          // If the assistant is hidden via the panel "X" (minimized), reopen the existing chat.
          if (!aiAssistantDisplayed && aiAssistantMinimized) {
            setAIAssistantStartNewChatOnOpen(false);
            setAIAssistantMinimized(false);
            setAIAssistantDisplayed(true);
            doTrack('AiAssistant', 'Show Ai Assistant from minimized');
            return;
          }

          // Clicking the header icon to close should behave as "close" (next open starts a new chat).
          if (aiAssistantDisplayed) {
            setAIAssistantMinimized(false);
            setAIAssistantStartNewChatOnOpen(true);
            setAIAssistantDisplayed(false);
            doTrack('AiAssistant', 'Close Ai Assistant from header sparkles');
            return;
          }

          // Opening from closed defaults to a new chat.
          setAIAssistantMinimized(false);
          setAIAssistantStartNewChatOnOpen(true);
          setAIAssistantDisplayed(true);
          doTrack('AiAssistant', 'Open Ai Assistant from header sparkles');
        }}
      />
    </>
  );
};
